import React, { useState, useEffect } from 'react';
import RichTextEditor from 'react-rte';
import Swal from 'sweetalert2';

const PageAdd = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [aboutContent, setAboutContent] = useState(RichTextEditor.createEmptyValue());
  const [termsContent, setTermsContent] = useState(RichTextEditor.createEmptyValue());
  const [privacyContent, setPrivacyContent] = useState(RichTextEditor.createEmptyValue());
  const [spPrivacyContent, setSpPrivacyContent] = useState(RichTextEditor.createEmptyValue());
  const [spOurFineContent, setSpOurFineContent] = useState(RichTextEditor.createEmptyValue());
  const [spAgreementContent, setSpAgreementContent] = useState(RichTextEditor.createEmptyValue());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPageData();
  }, []);

  const fetchPageData = async () => {
    try {
      // Fetch about us content
      const aboutResponse = await fetch('https://api.experts4u.in/api/v1/page/PageAdd/?type=aboutus');
      const aboutData = await aboutResponse.json();

      // Fetch terms content
      const termsResponse = await fetch('https://api.experts4u.in/api/v1/page/PageAdd/?type=terms');
      const termsData = await termsResponse.json();

      // Fetch privacy content
      const privacyResponse = await fetch('https://api.experts4u.in/api/v1/page/PageAdd/?type=privacy');
      const privacyData = await privacyResponse.json();

      // Fetch SP privacy content
      const spPrivacyResponse = await fetch('https://api.experts4u.in/api/v1/page/PageAdd/?type=spprivacy');
      const spPrivacyData = await spPrivacyResponse.json();

      // Fetch SP Our Fine Policy content
      const spOurFineResponse = await fetch('https://api.experts4u.in/api/v1/page/PageAdd/?type=spourfinepolicy');
      const spOurFineData = await spOurFineResponse.json();

      // Fetch SP Agreement content
      const spAgreementResponse = await fetch('https://api.experts4u.in/api/v1/page/PageAdd/?type=spagreement');
      const spAgreementData = await spAgreementResponse.json();

      // Set the content in editors if data exists
      if (aboutData.success && aboutData.data.length > 0) {
        setAboutContent(RichTextEditor.createValueFromString(aboutData.data[0].htmldata, 'html'));
      }

      if (termsData.success && termsData.data.length > 0) {
        setTermsContent(RichTextEditor.createValueFromString(termsData.data[0].htmldata, 'html'));
      }

      if (privacyData.success && privacyData.data.length > 0) {
        setPrivacyContent(RichTextEditor.createValueFromString(privacyData.data[0].htmldata, 'html'));
      }

      if (spPrivacyData.success && spPrivacyData.data.length > 0) {
        setSpPrivacyContent(RichTextEditor.createValueFromString(spPrivacyData.data[0].htmldata, 'html'));
      }

      if (spOurFineData.success && spOurFineData.data.length > 0) {
        setSpOurFineContent(RichTextEditor.createValueFromString(spOurFineData.data[0].htmldata, 'html'));
      }

      if (spAgreementData.success && spAgreementData.data.length > 0) {
        setSpAgreementContent(RichTextEditor.createValueFromString(spAgreementData.data[0].htmldata, 'html'));
      }

    } catch (error) {
      console.error('Error fetching page data:', error);
      Swal.fire("Error!", "Failed to fetch page data.", "error");
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      
      let type = '';
      let htmldata = '';

      // Get the current tab's content
      switch(activeTab) {
        case 'about':
          type = 'aboutus';
          htmldata = aboutContent.toString('html');
          break;
        case 'terms':
          type = 'terms';
          htmldata = termsContent.toString('html');
          break;
        case 'privacy':
          type = 'privacy';
          htmldata = privacyContent.toString('html');
          break;
        case 'spprivacy':
          type = 'spprivacy';
          htmldata = spPrivacyContent.toString('html');
          break;
        case 'spourfinepolicy':
          type = 'spourfinepolicy';
          htmldata = spOurFineContent.toString('html');
          break;
        case 'spagreement':
          type = 'spagreement';
          htmldata = spAgreementContent.toString('html');
          break;
        default:
          throw new Error('Invalid tab selected');
      }

      // Check if content is empty
      if (!htmldata.trim()) {
        Swal.fire("Error!", "Please add some content before saving.", "error");
        return;
      }

      console.log('Saving data:', { type, htmldata });

      const response = await fetch('https://api.experts4u.in/api/v1/page/PageAdd', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ type, htmldata })
      });

      const result = await response.json();
      console.log('Save response:', result);

      if (!response.ok || !result.success) {
        throw new Error(result.message || 'Failed to save content');
      }

      Swal.fire("Success!", "Content saved successfully!", "success");
      await fetchPageData(); // Refresh content after successful save
      
    } catch (error) {
      console.error('Error saving content:', error);
      Swal.fire("Error!", "Failed to save content. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-5">
      <div className="row justify-content-center">
        <div className="col-md-11">
          <div className="card shadow">
            <div className="card-header bg-white">
              <ul className="nav nav-tabs card-header-tabs">
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'about' ? 'active' : ''}`}
                    onClick={() => setActiveTab('about')}
                  >
                    About Us
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'terms' ? 'active' : ''}`}
                    onClick={() => setActiveTab('terms')}
                  >
                    Terms & Conditions
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'privacy' ? 'active' : ''}`}
                    onClick={() => setActiveTab('privacy')}
                  >
                    Privacy Policy
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'spprivacy' ? 'active' : ''}`}
                    onClick={() => setActiveTab('spprivacy')}
                  >
                   SP Privacy Policy
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'spourfinepolicy' ? 'active' : ''}`}
                    onClick={() => setActiveTab('spourfinepolicy')}
                  >
                   SP Our Fine Policy
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'spagreement' ? 'active' : ''}`}
                    onClick={() => setActiveTab('spagreement')}
                  >
                   SP Agreement
                  </button>
                </li>
              </ul>
            </div>
            <div className="card-body p-4">
              {activeTab === 'about' && (
                <div>
                  <h2 className="mb-4">About Us</h2>
                  <div style={{ minHeight: '600px', border: '1px solid #ddd', borderRadius: '4px' }}>
                    <RichTextEditor
                      value={aboutContent}
                      onChange={setAboutContent}
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
              )}
              {activeTab === 'terms' && (
                <div>
                  <h2 className="mb-4">Terms & Conditions</h2>
                  <div style={{ minHeight: '600px', border: '1px solid #ddd', borderRadius: '4px' }}>
                    <RichTextEditor
                      value={termsContent}
                      onChange={setTermsContent}
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
              )}
              {activeTab === 'privacy' && (
                <div>
                  <h2 className="mb-4">Privacy Policy</h2>
                  <div style={{ minHeight: '600px', border: '1px solid #ddd', borderRadius: '4px' }}>
                    <RichTextEditor
                      value={privacyContent}
                      onChange={setPrivacyContent}
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
              )}
              {activeTab === 'spprivacy' && (
                <div>
                  <h2 className="mb-4">SP Privacy Policy</h2>
                  <div style={{ minHeight: '600px', border: '1px solid #ddd', borderRadius: '4px' }}>
                    <RichTextEditor
                      value={spPrivacyContent}
                      onChange={setSpPrivacyContent}
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
              )}
              {activeTab === 'spourfinepolicy' && (
                <div>
                  <h2 className="mb-4">SP Our Fine Policy</h2>
                  <div style={{ minHeight: '600px', border: '1px solid #ddd', borderRadius: '4px' }}>
                    <RichTextEditor
                      value={spOurFineContent}
                      onChange={setSpOurFineContent}
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
              )}
              {activeTab === 'spagreement' && (
                <div>
                  <h2 className="mb-4">SP Agreement</h2>
                  <div style={{ minHeight: '600px', border: '1px solid #ddd', borderRadius: '4px' }}>
                    <RichTextEditor
                      value={spAgreementContent}
                      onChange={setSpAgreementContent}
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
              )}
              <div className="text-end mt-4">
                <button 
                  className="btn btn-primary btn-lg px-5 py-2"
                  onClick={handleSave}
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAdd;